import { render, staticRenderFns } from "./AInfo.vue?vue&type=template&id=2333b174&scoped=true&"
import script from "./AInfo.vue?vue&type=script&lang=ts&"
export * from "./AInfo.vue?vue&type=script&lang=ts&"
import style0 from "./AInfo.vue?vue&type=style&index=0&id=2333b174&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2333b174",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
